import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import { Order } from '../../models';

interface CompletePaymentProps {
  order: Order;
}

export const CompletePayment = (props: CompletePaymentProps) => {
  const { order } = props;

  const completePayment = () => {
    // Use Stripe Checkout Session flow
    window.open(order.stripeInvoiceUrl, '_blank');
  };

  return (
    <Button
      id="complete-payment-btn"
      variant="contained"
      onClick={completePayment}
      sx={{
        height: 44,
        padding: '0 24px',
        borderRadius: '10px',
        backgroundColor: '#0F8461',
        color: '#fff',
        fontSize: 14,
        fontWeight: 600,
        textTransform: 'none',
        '&:hover': {
          backgroundColor: '#0B6B4E',
        },
      }}
    >
      <FormattedMessage
        id="pending.order.complete.payment"
      />
    </Button>
  );
};
